import type { ReferralConfigType } from "@/types/ReferralObjectTypes";
import WebshareApi from "..";

export const getReferralConfig = () => WebshareApi.get("/referral/config/");

export const updateReferralConfig = (params: Partial<ReferralConfigType>) =>
  WebshareApi.patch("/referral/config/", params);

export const REFERRAL_CHANNELS_URL = "/referral/channel/";
